import { eventBus } from '@/libs/eventBus';
import { useFeatureValue } from '@growthbook/growthbook-react';
import { useEffect } from 'react';

// TT-133: version-one owns the Wakala dashboard card + detail view but can't
// read GrowthBook (host-only SDK). Host reads enable-wakala-widget and relays it
// over the single-spa bus. Emits on change, and re-emits on request so
// version-one gets the value whenever it (re)subscribes, regardless of when the
// flag resolves. Renders nothing.
export function WakalaFlagRelay() {
  const enabled = useFeatureValue('enable-wakala-widget', false);

  useEffect(() => {
    eventBus.emit('mife:wakala-widget-flag', { enabled });
    const onRequest = () => eventBus.emit('mife:wakala-widget-flag', { enabled });
    eventBus.on('mife:request-wakala-widget-flag', onRequest);
    return () => eventBus.off('mife:request-wakala-widget-flag', onRequest);
  }, [enabled]);

  return null;
}
